import InvoiceService from '@/store/services/invoice.service.js'
import QuotationService from '@/store/services/quotation.service.js'
import CustomerService from '@/store/services/customer.service.js'
import CostService from '@/store/services/cost.service.js'
import TripService from '@/store/services/trip.service'
import HoursService from "@/store/services/hour.service.js";

const serviceMap = {
  invoices: InvoiceService.customerList,
  quotations: QuotationService.customerList,
  costs: CostService.customerList,
  trips: TripService.customerList,
  hours: HoursService.getCustomerList
}
const companyMap = {
  invoices: 'sender_company',
  quotations: 'sender_company',
  costs: 'owner_company',
  trips: 'owner_company',
  hours: 'owner_company'
}
export default {
  namespaced: true,
  state: {
    customers: {
      invoices: [],
      quotations: [],
      costs: [],
      recurrent: [],
      trips: [],
      hours: []
    }
  },
  getters: {
    getCustomers: state => type => state.customers[type],

    getCustomerById: state => (type, id) =>
      state.customers[type]?.find(customer => customer.id === id),

    getCustomerByProjectId: state => (type, projectId) =>
      state.customers[type]?.find(customer =>
        customer.projects?.some(project => project.id === projectId)
      )
  },
  mutations: {
    SET_CUSTOMERS(state, { type, customers }) {
      // Merge existing customers with the new ones, avoiding duplicates
      const existingCustomers = state.customers[type] || []

      // Only add customers that don't already exist
      const newCustomers = customers.filter(newCustomer =>
        !existingCustomers.some(existingCustomer => existingCustomer.id === newCustomer.id)
      )

      // Combine the existing customers with the new ones (without duplicates)
      state.customers[type] = [...existingCustomers, ...newCustomers]
    },
    ADD_CUSTOMER(state, { type, customer }) {
      const exists = state.customers[type]?.some(c => c.id === customer.id)
      if (!exists) {
        state.customers[type].push(customer)
      }
    }
  },
  actions: {
    loadCustomers({ commit, rootGetters }, type) {
      const companyId = rootGetters['main/getCurrentCompany'].id
      return serviceMap[type]({ useCache: true, [companyMap[type]]: companyId }).then(response => {
        commit('SET_CUSTOMERS', { type, customers: response.data })
      })
    },
    retrieveCustomer({ commit }, { type, customerId }) {
      return CustomerService.retrieve(customerId, { useCache: true }).then(response => {
        commit('ADD_CUSTOMER', { type, customer: response.data })
        return response.data
      })
    },
    retrieveCustomerByProject({ commit }, { type, projectId }) {
      return CustomerService.retrieveByProjectId({ project_id: projectId, extended: 'True', useCache: true }).then(response => {
        commit('ADD_CUSTOMER', { type, customer: response.data[0] })
        return response.data[0]
      })
    }
  }
}
